import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTrail, animated } from 'react-spring';
import MobileNavbarContext from '../mobile-navbar-context';
import ExpandableMenu from './expandable-menu';
import MenusContext from './menus-context';

const reducer = (state, { type, payload }) => {
  switch (type) {
    // We only allow one expanded menu item at a time.
    case 'setExpandedMenu':
      return { ...state, expandedMenu: payload };
    default:
      throw new Error();
  }
};

function getRealMenus(arr) {
  return _(arr)
    .map((action, text) => ({ text, action }))
    .filter(({ action }) => !(_.isArray(action) && !action.length))
    .value();
}

export default function Menus(props) {
  const [state, dispatch] = React.useReducer(reducer, { expandedMenu: null });
  const { state: { menus } } = React.useContext(MobileNavbarContext);
  const [displayableMenus, setDisplayableMenus] = React.useState(getRealMenus(menus));
  const trail = useTrail(displayableMenus.length, {
    opacity: 1,
    transform: 'translateY(-50%)',
    from: {
      opacity: 0,
      transform: 'translate(0)',
    },
    config: { mass: 1, tension: 500, friction: 30 },
    ref: props.trailRef,
  });

  React.useEffect(() => {
    setDisplayableMenus(getRealMenus(menus));
  }, [menus]);

  return (
    <MenusContext.Provider value={{ state, dispatch }}>
      <ul>
        {trail.map((style, index) => {
          const { text, action } = displayableMenus[index];
          return (
            <animated.li
              key={text}
              className={classNames({ expandable: _.isArray(action) })}
              style={style}
            >
              {_.isFunction(action) && action()}
              {_.isString(action) && <a href={action}>{text}</a>}
              {_.isArray(action) && <ExpandableMenu text={text} action={action} />}
            </animated.li>
          );
        })}
      </ul>
    </MenusContext.Provider>
  );
}

Menus.propTypes = {
  trailRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.instanceOf(Element),
    }),
  ]).isRequired,
};
